export const CONTENT_DATA_TEST_ID = 'ratio-wrapper-content'
export const RESIZE_EVENT = 'resize'
export const SCALE_MIN = 0.3
export const WRAPPER_DATA_TEST_ID = 'ratio-wrapper'
